
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from 'firebase';
import vuetify from './plugins/vuetify';
import VueGtag from 'vue-gtag';
Vue.use(VueGtag, {
  id: 'G-JP5FGHMB9C', // Your Google Analytics tracking ID
});
Vue.config.productionTip = false

let app = '';
// const sql = require('mssql')
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}
const firebaseConfig = {
  apiKey: "AIzaSyDtEVGDPadT-2LXaOTTwpr9tzCjbc6X4Qo",
  authDomain: "tribunes-sa.firebaseapp.com",
  databaseURL: "https://tribunes-sa.firebaseio.com",
  projectId: "tribunes-sa",
  storageBucket: "tribunes-sa.appspot.com",
  messagingSenderId: "1076497216756",
  appId: "1:1076497216756:web:0a915321edd08f08715aa1",
  measurementId: "G-JP5FGHMB9C"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
// db.settings({ timestampsInSnapshots: true });



firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
});

export default db;
